import React from 'react'
import {Grid, Typography} from '@mui/material';
import {styled} from "@mui/material/styles";

const NoDataImg = styled('img')(() => ({
    width: '30em',
    height: '30em',
    objectFit: 'cover',
}));

const NoDataText = styled(Typography)(() => ({
    color: 'rgba(0, 0, 0, 1)',
    fontSize: '.9em',
    fontWeight: 'normal',
    lineHeight: '1.5em',
    fontFamily: 'Inter, sans-serif',
    textAlign: 'center',
    marginTop: '1em',
}));

const NoDataCenterPosition = styled(Grid)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export interface INoDataMessage {
    /** the src value to render an image other than the default */
    image?: string,
    /** text to render instead of the default */
    message?: string,
    /** applied directly to the Typography component */
    textStyle?:string,
    /** applied to the parent grid of the Image component */
    propStyling?: string
}

/**
 * Old image with loading alt
 * @param image
 * @param message
 * @param textStyle
 * @param propStyling
 * @constructor
 * @deprecated
 */
const NoDataMessage = ({
    image = 'https://s3-us-west-1.amazonaws.com/securspace-files/listing-images/a80edbe2-b50c-4332-a711-a75ceed6bef9_Artwork.png',
    message = 'No input selected, To view results kindly select the data above.',
    textStyle,
    propStyling
}: INoDataMessage) => {
    return (
        <Grid container justifyContent='center' alignItems='center'>
            <Grid item>
                <NoDataCenterPosition item className={propStyling}>
                    <NoDataImg src={image} alt="No Data Image" />
                </NoDataCenterPosition>
                <NoDataText className={textStyle} variant='body2'>
                    {message}
                </NoDataText>
            </Grid>
        </Grid>
    )
}


export default NoDataMessage
